import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { publicAxios } from "@/lib/axios";
import { handleApiError } from "@/lib/utils";

export async function getEvents(startDate: string, endDate: string) {
	try {
		const response = await publicAxios.get(
			ADMIN_API_ENDPOINTS.LIVE_LECTURE.GET_EVENTS,
			{
				params: {
					startDate: startDate,
					endDate: endDate,
				},
			}
		);

		if (response?.status === 200) {
			const rawEvents = response?.data?.data || [];

			// Transform backend format to react-big-calendar format
			const transformedEvents = rawEvents.map((event: any) => {
				// Combine date and time into Date objects
				const startDateTime = new Date(
					`${event.start_date}T${event.start_time}`
				);
				const endDateTime = new Date(`${event.end_date}T${event.end_time}`);

				return {
					title: event.subject_name || event.course_name || "Untitled Event",
					start: startDateTime,
					end: endDateTime,
					eventDetails: {
						id: String(event.id),
						courseName: event.course_name,
						semYear: event.sem_year,
						batch: event.batch,
						startDate: event.start_date,
						startTime: event.start_time,
						endDate: event.end_date,
						endTime: event.end_time,
						subjectName: event.subject_name,
					},
				};
			});

			return transformedEvents;
		}

		return [];
	} catch (error) {
		const errorResponse = handleApiError(error as AxiosError);
		console.error("Error fetching events:", errorResponse);
		return [];
	}
}

export async function getEventOptions() {
	try {
		const response = await publicAxios.get(
			ADMIN_API_ENDPOINTS.LIVE_LECTURE.GET_OPTIONS
		);

		if (response?.status === 200) {
			const flatArray = response?.data?.data || [];

			// Convert flat array to grouped format for dropdowns
			// Input: [{ id: 1, category: "courseName", option: "MBA" }, ...]
			// Output: { courseName: ["MBA", ...], semYear: [...], batch: [...] }
			const grouped = flatArray.reduce((acc: any, item: any) => {
				if (!acc[item.category]) {
					acc[item.category] = [];
				}
				acc[item.category].push(item.option);
				return acc;
			}, {});

			return grouped;
		}

		return {};
	} catch (error) {
		const errorResponse = handleApiError(error as AxiosError);
		console.error("Error fetching event options:", errorResponse);
		return {};
	}
}
